var _objectSpread = require("E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
var _objectWithoutProperties = require("E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/objectWithoutProperties.js").default;
var _excluded = ["class", "staticClass", "style", "staticStyle", "attrs"];
require("core-js/modules/es.array.concat.js");
module.exports = {
  functional: true,
  render: function render(_h, _vm) {
    var _c = _vm._c,
      _v = _vm._v,
      data = _vm.data,
      _vm$children = _vm.children,
      children = _vm$children === void 0 ? [] : _vm$children;
    var classNames = data.class,
      staticClass = data.staticClass,
      style = data.style,
      staticStyle = data.staticStyle,
      _data$attrs = data.attrs,
      attrs = _data$attrs === void 0 ? {} : _data$attrs,
      rest = _objectWithoutProperties(data, _excluded);
    return _c('svg', _objectSpread({
      class: ["icon", classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "width": "200",
        "height": "200",
        "viewBox": "0 0 1024 1024",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs)
    }, rest), children.concat([_c('path', {
      attrs: {
        "d": "M936.7 612.2c-1-119.8-100.1-213.8-219.1-232.7C692 246.6 561.9 149 406 148.7 240.7 148.9 91.2 269 89.9 426.5c.4 83.8 49.7 154.4 113.6 207.7l-19.7 66.7c-3.5 11.6.4 23.9 9.8 31.5 9.4 7.5 22.3 8.6 32.8 2.8l82.5-46c15.6 3.8 31.6 7.7 48.2 10.6 15.8 2.7 32 4.6 48.8 4.6 8.8 0 17.3-.6 25.9-1.2 39.6 86.3 133.5 145.3 242.5 145.5 28-.1 53.9-6.2 77.8-12.2l65 37.1c10.5 6 23.5 5 32.9-2.5 9.4-7.4 13.4-19.9 10.1-31.4l-15.3-53c51.6-44.9 91.5-104 91.9-174.5zM406 645.3c-12.3 0-25.2-1.4-38.7-3.7-17.7-3-36.2-7.8-55.4-12.5l-21.5 2.8-29.4 16.4 4.8-16.3c3.5-11.8-.6-24.4-10.4-31.9-63.7-48.5-106.8-110.4-106.4-173.6.3-116.1 118.9-218.5 257-218.7 126.1.3 224.2 74.2 250.3 168.9-135.7 8.5-244 108.3-244.4 235.5 0 11.1 1.2 22 2.8 32.6-2.9.1-5.8.5-8.7.5zm376.9 139.4l.4 1.4-12-6.9-21.9-3c-27.5 7.1-52.9 13.4-74.9 13.3-116.8-.4-203.2-81.8-203.4-177.3.2-95.2 86.7-177 203.4-177.3 109.1.2 203 83.4 203.2 177.3.4 50.7-33.6 101.2-84.6 141-9.6 7.4-13.6 19.9-10.2 31.5z"
      }
    }), _c('path', {
      attrs: {
        "fill": "currentColor",
        "d": "M286.5 316.3c-27.2 0-49.2 22-49.2 49.2 0 27.2 22 49.2 49.2 49.2 27.2 0 49.2-22 49.2-49.2.1-27.2-22-49.2-49.2-49.2zm177.2 98.4c27.2 0 49.3-22 49.3-49.2 0-27.2-22-49.2-49.3-49.2-27.2 0-49.2 22-49.2 49.2 0 27.2 22.1 49.2 49.2 49.2zm147.8 137.9c-2.7 0-5.4.3-7.9.8-17.9 3.7-31.4 19.5-31.4 38.6 0 19 13.5 34.9 31.4 38.6 2.6.5 5.2.8 7.9.8 21.7 0 39.4-17.6 39.4-39.4 0-21.8-17.7-39.4-39.4-39.4zm137.8 0c-8.2 0-15.7 2.5-22 6.7-6.3 4.2-11.3 10.3-14.3 17.3-2 4.7-3.1 9.9-3.1 15.3s1.1 10.6 3.1 15.3c3 7.1 8 13.1 14.3 17.3 6.3 4.2 13.9 6.7 22 6.7 21.8 0 39.4-17.6 39.4-39.4 0-21.6-17.6-39.2-39.4-39.2z"
      }
    })]));
  }
};